export default class RegExpUtil {
    escapeRegExp = text => {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
}